export default __webpack_public_path__ + "static/media/reunion222.5f5f61d4.jpg";